import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { LanguageList, LanguageActive } from '../../components/LanguageList';
import { LanguageConsumer, Translate } from '../../contexts/LanguageContext';
import { AuthConsumer } from '../../contexts/AuthContext';
import { Config } from '../../helpers/Config';


class Header extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.toggleLanguage = this.toggleLanguage.bind(this);
        this.toggleprofile = this.toggleprofile.bind(this);

        this.state = {
            dropdownOpen: false,
            dropdownOpenLanguage: false,
            dropdownOpenprofile: false,
            user: {}
        };
    }
    componentDidMount() {


        this.setState({
            user: JSON.parse(localStorage.getItem('user'))
        });

    }
    toggle() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }
    toggleLanguage() {
        this.setState(prevState => ({
            dropdownOpenLanguage: !prevState.dropdownOpenLanguage
        }));
    }
    toggleprofile() {
        this.setState(prevState => ({
            dropdownOpenprofile: !prevState.dropdownOpenprofile
        }));
    }
    togglescreen(e) {
        if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {  // current working methods
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }
    }

    render() {
        return (
            <LanguageConsumer>
                {({ language, changeLanguage }) => (
                    <AuthConsumer>
                        {({ logoutHandler }) => (

                            <div className="topbar">
                                <div className="topbar-left">
                                    <Link to="/" className="logo">
                                        <span className="logo-wrapper">
                                            <img src="/assets/images/logo/logo-light.svg" alt="" height="17" />
                                            <span className="logo-subtitle">CUSTOMER PANEL</span>
                                        </span>
                                        <i>
                                            <img src="/assets/images/logo/logo-icon-light.svg" alt="" height="22" />
                                        </i>
                                    </Link>
                                </div>
                                {Config.appSettings.debug ? <span className="alert alert-danger font-16 mt-3 p-3 debug-mode">{Translate("DEBUG")}</span> : null}
                                <nav className="navbar-custom">
                                    <ul className="navbar-right d-flex list-inline float-right mb-0">
                                        <li className="dropdown notification-list d-none d-md-block">
                                            <Dropdown isOpen={this.state.dropdownOpenLanguage} toggle={this.toggleLanguage}>
                                                <DropdownToggle className="nav-link dropdown-toggle arrow-none testflag waves-effect" caret tag="a">
                                                    <LanguageActive lang={language} />
                                                </DropdownToggle>
                                                <DropdownMenu className="dropdown-menu dropdown-menu-right language-switch">
                                                    <LanguageList lang={language} handleClick={(e, lang) => { changeLanguage(e, lang); this.toggleLanguage() }} />
                                                </DropdownMenu>
                                            </Dropdown>
                                        </li>
                                        <li className="dropdown notification-list d-none d-md-block">
                                            <Link onClick={() => this.togglescreen()} className="nav-link waves-effect" to="#" id="btn-fullscreen">
                                                <i className="mdi mdi-fullscreen noti-icon"></i>
                                            </Link>
                                        </li>
                                        <li className="dropdown notification-list">
                                            <div className="dropdown notification-list nav-pro-img">
                                                <Dropdown isOpen={this.state.dropdownOpenprofile} toggle={this.toggleprofile}>
                                                    <DropdownToggle className="dropdown-toggle testflag nav-link arrow-none waves-effect nav-user" tag="a">
                                                        <img src="/assets/images/users/user-none.png" alt="user" className="rounded-circle" /> &nbsp; {this.state.user.name} ({this.state.user.login}) &nbsp; <span className="mdi mdi-chevron-down"></span>
                                                    </DropdownToggle>
                                                    <DropdownMenu>
                                                        <DropdownItem><Link to="/user-accounts" className="d-block"><i className="mdi mdi-account-circle m-r-5"></i>{Translate('Profile')}</Link></DropdownItem>
                                                        {/* <DropdownItem><Link to="/settings" className="d-block"><i className="mdi mdi-settings m-r-5"></i>{Translate('Settings')}</Link></DropdownItem> */}
                                                        <DropdownItem onClick={(e) => { logoutHandler(e) }}><i className="mdi mdi-power text-danger m-r-5"></i>{Translate('Logout')}</DropdownItem>
                                                    </DropdownMenu>
                                                </Dropdown>
                                            </div>
                                        </li>
                                    </ul>
                                    <ul className="list-inline menu-left mb-0">
                                        <li className="float-left">
                                            <button className="button-menu-mobile open-left waves-effect">
                                                <i className="mdi mdi-menu"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        )}
                    </AuthConsumer>
                )}
            </LanguageConsumer>
        );
    }
}

export default Header;